import React, { useEffect, useRef, useState } from 'react';
import { apc } from '../motivated-skills/theme';
import { takeTicketFromUrl, redeemAndSignIn, journeyLink, fullLoad } from '../../lib/launch';

// S5b.2: /launch?t={ticket}. The ticket leaves the address bar before anything
// else happens, then it is spent once and the client is taken to the
// assessment's own start. A used, expired or unknown link says so, with the
// way back to their journey.

const box = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: apc.paper,
  color: apc.ink,
  fontFamily: apc.body,
  padding: 24,
};

export default function LaunchPage() {
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    // Once per page, so a double-run effect can never spend the ticket twice.
    if (started.current) return;
    started.current = true;
    const ticket = takeTicketFromUrl();
    if (!ticket) {
      setFailed(true);
      return;
    }
    redeemAndSignIn(ticket)
      .then(({ route }) => {
        // A full load, not an in-app hop (2026-10-30): the auth provider decides
        // launch-or-default once, on mount, so a hop kept it on the default user
        // and the flow asked a launched client to sign in with Google.
        if (route) fullLoad(route);
        else setFailed(true);
      })
      .catch(() => setFailed(true));
  }, []);

  if (failed) {
    return (
      <main style={box}>
        <div style={{ maxWidth: 520 }}>
          <h1 style={{ fontFamily: apc.display, fontSize: 28, color: apc.navy, margin: '0 0 12px' }}>
            That link has been used. Go back to your journey and open it again.
          </h1>
          <a href={journeyLink()} style={{ color: apc.navy, fontWeight: 600, fontSize: 16 }}>
            Back to your journey
          </a>
        </div>
      </main>
    );
  }

  return (
    <main style={box} aria-busy="true">
      <p style={{ fontSize: 16, color: apc.muted }}>Opening your assessment</p>
    </main>
  );
}
